import { useTheme, useMediaQuery } from '@mui/material';

/**
 * Returns the current MUI breakpoint token: 'xs' | 'sm' | 'md' | 'lg' | 'xl'.
 *
 * Used by ResponsiveDataGrid, ResponsiveDrawer, ResponsiveDialog, EdgeSheet,
 * and FormActions to make layout decisions without each component duplicating
 * multiple useMediaQuery calls.
 *
 * MUI defaults:
 *   xs  ≥ 0 px
 *   sm  ≥ 600 px
 *   md  ≥ 900 px
 *   lg  ≥ 1200 px
 *   xl  ≥ 1536 px
 */
export default function useBreakpoint() {
  const theme = useTheme();

  // Evaluate from largest → smallest so the first true match wins.
  // useMediaQuery is always called in the same order (rules of hooks).
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));

  if (isXl) return 'xl';
  if (isLg) return 'lg';
  if (isMd) return 'md';
  if (isSm) return 'sm';
  return 'xs';
}
